<div class="flex flex-row gap-4 items-center my-2">
  <i [className]="'pi ' + icon()"></i>
  <div>
    <p class="text font-medium">{{title()}}</p>
    <div class="text-surface-500 text-sm">
      <ng-content/>
    </div>
  </div>
</div>
<p-divider/>
